/** Resolves avatar URLs that may be relative backend paths (e.g., /uploads/...).
 *  Mirrors init.ts → resolveApiBase: env override wins, otherwise derive from
 *  the page's host so phone-via-LAN-IP works without env tweaking. */
function resolveOrigin(): string {
  let apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl && typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      apiUrl = 'http://localhost:3001/api/v1';
    } else {
      const isPrivateLan =
        /^10\./.test(host) ||
        /^192\.168\./.test(host) ||
        /^172\.(1[6-9]|2\d|3[0-1])\./.test(host);
      apiUrl = isPrivateLan
        ? `http://${host}:3001/api/v1`
        : `${window.location.origin}/api/v1`;
    }
  }
  if (!apiUrl) apiUrl = 'http://localhost:3001/api/v1';
  return apiUrl.replace(/\/api(\/v\d+)?$/, '');
}
const API_ORIGIN = resolveOrigin();

export function resolveAvatarUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/')) return `${API_ORIGIN}${url}`;
  return url;
}
